import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from '../../components/button/button';
import { ButtonSize } from '../../core/enums';
import { ButtonVariant } from '../../core/enums';
import { Checkbox } from '@chakra-ui/react';
import { Flex } from '@chakra-ui/react';
import { Select } from '../../components/select/select';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { chooseServiceLine } from '../../actions/service-lines';
import { saveUserPreference } from '../../actions/user-preferences';
import { commonEnums } from '@codametrix/ui-common';
const { UserPreferenceKey } = commonEnums;
const ServiceLines = ()=>{
    const { context } = useSelector((state)=>state.ui);
    const { activeContext } = context;
    const { loading, activeUser, homepagePreference } = useSelector((state)=>state.ui);
    const dispatch = useDispatch();
    useEffect(()=>{
        if (activeContext?.serviceLines === null) {
            history.push('/');
        }
    }, [
        dispatch,
        activeContext
    ]);
    const [selectedServiceLine, selectServiceLine] = useState(null);
    const [selectedServiceLineName, selectServiceLineName] = useState('');
    const [isDefault, setIsDefault] = useState(false);
    const history = useHistory();
    const handleDefaultCheck = (e)=>{
        setIsDefault(!isDefault);
    };
    const handleSave = (e)=>{
        if (e) {
            e.preventDefault();
            if (selectedServiceLine !== null) {
                const serviceLine = activeContext?.serviceLines.find((serviceLine)=>serviceLine.id === selectedServiceLine);
                if (serviceLine) {
                    dispatch(chooseServiceLine({
                        serviceLine,
                        context,
                        homepagePreference
                    }));
                }
                if (isDefault) {
                    dispatch(saveUserPreference({
                        userId: activeUser.id,
                        value: selectedServiceLine.toString(),
                        keyname: UserPreferenceKey.DEFAULT_USER_SERVICE_LINE
                    }));
                }
            }
        }
    };
    const handleServiceLineChoice = (event)=>{
        const target = event.target;
        const { value, textContent } = target;
        selectServiceLine(+value);
        selectServiceLineName(textContent);
    };
    const handleBackSelection = (e)=>{
        if (e) {
            e.preventDefault();
            history.goBack();
        }
    };
    const convertServiceLines = (items)=>{
        return items.map((item)=>({
                value: item?.id,
                label: item?.displayName || item?.name
            }));
    };
    const activeOrgDisplay = context.activeContext?.displayName && context.activeContext?.displayName !== '' ? context.activeContext?.displayName : context.activeContext?.shortDisplayName && context.activeContext?.shortDisplayName !== '' ? context.activeContext?.shortDisplayName : context.activeContext?.organizationCode && context.activeContext?.organizationCode !== '' ? context.activeContext?.organizationCode : '';
    return /*#__PURE__*/ _jsxs("div", {
        className: "service-line-choice-form form-group",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "form-row",
                children: [
                    /*#__PURE__*/ _jsxs("label", {
                        className: "form-label",
                        children: [
                            "Which service line at ",
                            activeOrgDisplay,
                            "?"
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Select, {
                        placeholder: "Choose your service line",
                        items: convertServiceLines(activeContext?.serviceLines),
                        value: selectedServiceLineName,
                        onChange: handleServiceLineChoice
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "checkbox-container",
                children: [
                    /*#__PURE__*/ _jsx(Checkbox, {
                        onChange: handleDefaultCheck
                    }),
                    /*#__PURE__*/ _jsx("i", {
                        className: "form-icon"
                    }),
                    " Default service line"
                ]
            }),
            /*#__PURE__*/ _jsxs(Flex, {
                className: "form-buttons",
                children: [
                    /*#__PURE__*/ _jsx(Button, {
                        size: ButtonSize.MD,
                        label: "Back",
                        variant: ButtonVariant.LINKS,
                        dataTestId: "back",
                        onClick: handleBackSelection
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        size: ButtonSize.MD,
                        label: 'Continue',
                        variant: ButtonVariant.PRIMARY,
                        disabled: !selectedServiceLine || loading,
                        name: "Continue",
                        dataTestId: "continue",
                        onClick: handleSave
                    })
                ]
            })
        ]
    });
};
export default ServiceLines;
